export { VpButtonGroup } from './VpButtonGroup';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpButtonGroup/index.js